import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import dateTimeUtils from '../utils/DateTimeUtils';
import Logger from '../utils/Logger';
import { version, commit } from '../utils/version';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useDispatch, useSelector } from 'react-redux';
import { toggleShowResetButton } from '../features/counters/countersSettingsSlice';
import { setSlotsLayoutMode } from '../features/slots/slotsLayoutSlice';
import { setThemeMode } from '../features/theme/themeSlice';
import { checkForUpdate } from '../pwa';
export const About = () => {
    const dispatch = useDispatch();
    const { showResetButton } = useSelector((state) => state.countersSettings);
    const { mode: slotsLayoutMode } = useSelector((state) => state.slotsLayout);
    const { mode: themeMode } = useSelector((state) => state.theme);
    const [updateStatus, setUpdateStatus] = React.useState('idle');
    const checkUpdates = async () => {
        setUpdateStatus('checking');
        const found = await checkForUpdate();
        setUpdateStatus(found ? 'found' : 'current');
    };
    const [messages, setMessages] = React.useState([]);
    const getMessages = async () => {
        try {
            const messages = await Logger.getAllLogs();
            setMessages(messages);
        }
        catch (err) {
            console.error(err);
        }
    };
    getMessages();
    const rows = messages.sort((a, b) => (b.created - a.created));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            "Version: ",
            version),
        React.createElement("div", { style: { color: "grey", fontSize: "0.55em" } }, commit),
        React.createElement(Box, { sx: {
                margin: '16px 0',
                padding: '12px',
                border: '1px solid #e0e0e0',
                borderRadius: '4px'
            } },
            React.createElement(Typography, { variant: "h6", sx: { mb: 1 } }, "Settings"),
            React.createElement(FormControlLabel, { control: React.createElement(Switch, { checked: showResetButton, onChange: () => dispatch(toggleShowResetButton()) }), label: "Show Reset Button in Daily Counters" }),
            React.createElement(Typography, { sx: { mt: 2 } }, "Slots Layout"),
            React.createElement(ToggleButtonGroup, { exclusive: true, size: "small", value: slotsLayoutMode, onChange: (_, value) => {
                    if (value !== null) {
                        dispatch(setSlotsLayoutMode(value));
                    }
                } },
                React.createElement(ToggleButton, { value: "auto" }, "Auto"),
                React.createElement(ToggleButton, { value: "portrait" }, "Portrait"),
                React.createElement(ToggleButton, { value: "landscape" }, "Landscape")),
            React.createElement(Typography, { sx: { mt: 2 } }, "Theme"),
            React.createElement(ToggleButtonGroup, { exclusive: true, size: "small", value: themeMode, onChange: (_, value) => {
                    if (value !== null) {
                        dispatch(setThemeMode(value));
                    }
                } },
                React.createElement(ToggleButton, { value: "light" }, "Light"),
                React.createElement(ToggleButton, { value: "dark" }, "Dark"),
                React.createElement(ToggleButton, { value: "system" }, "System")),
            React.createElement(Typography, { sx: { mt: 2 } }, "App Updates"),
            React.createElement(Button, { size: "small", variant: "outlined", disabled: updateStatus === 'checking', onClick: checkUpdates }, "Check for updates"),
            updateStatus === 'checking' && React.createElement(Typography, { variant: "caption", sx: { ml: 1 } }, "Checking\u2026"),
            updateStatus === 'current' && React.createElement(Typography, { variant: "caption", sx: { ml: 1 } }, "Up to date"),
            updateStatus === 'found' && React.createElement(Typography, { variant: "caption", sx: { ml: 1 } }, "Update ready - tap the Refresh app button under the toolbar to load it")),
        React.createElement(Button, { onClick: clear }, "Clear"),
        React.createElement(TableContainer, { component: Paper },
            React.createElement(Table, { sx: { minWidth: 650 }, size: "small", "aria-label": "log-table" },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null, "Date"),
                        React.createElement(TableCell, null, "Message"))),
                React.createElement(TableBody, null, rows.map((row) => (React.createElement(TableRow, { sx: { "& td": { fontSize: "0.6em" } } },
                    React.createElement(TableCell, { sx: { fontSize: "0.75em" } }, dateTimeUtils(row.created).format("YYYY-M-D, h:mm:ss a")),
                    React.createElement(TableCell, null, row.msg.toString())))))))));
};
function clear() {
    Logger.clear();
}
